import { graphQLClient } from '@api/client';
import { useTreatmentHistoryDetailQuery } from '@api/GoodocAPI';
import { DeliveryMethod } from '@context/Delivery/types';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { PRESCRIPTION_DELIVERY_VISIT } from '@pages/Prescription/focusKey';
import { generateDeliveryPath } from '@router/path';
import constate from 'constate';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const usePrescription = () => {
  const { treatmentId = '' } = useParams();
  const { data: treatmentHistoryDetailResponse } = useTreatmentHistoryDetailQuery(
    graphQLClient,
    { treatmentId }
  );

  const treatment = treatmentHistoryDetailResponse?.treatmentV3;

  const { setFocus } = useFocusable();

  const setButtonFocus = useCallback(() => {
    setFocus(PRESCRIPTION_DELIVERY_VISIT);
  }, [setFocus]);

  const navigate = useNavigate();

  const goDelivery = useCallback(
    (deliveryMethod: DeliveryMethod) => {
      switch (deliveryMethod) {
        case 'visit':
          navigate(generateDeliveryPath(treatmentId, deliveryMethod));
          break;
      }
    },
    [navigate, treatmentId]
  );

  const goBack = () => {
    navigate(-1);
  };

  return {
    treatment,
    setButtonFocus,
    goDelivery,
    goBack
  };
};

export const [PrescriptionProvider, usePrescriptionContext] = constate(usePrescription);
